import { DirectionalLight } from '@babylonjs/core/Lights/directionalLight';
export const checkDirectionalLight = (v) => {
    if (!(v instanceof DirectionalLight)) {
        throw new Error(`Expected DirectionalLight, but received ${String(v)}`);
    }
    return v;
};
